import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const Cookie = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.overflowX = 'hidden';
    }

    return () => {
      document.body.style.overflow = '';
      document.body.style.overflowX = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-start justify-center bg-[#1c1c29]/20 backdrop-blur-md transition-opacity duration-300 px-2 sm:px-4 py-6 overflow-y-auto">
      <div
        className="relative bg-[#1c1c29] backdrop-blur-lg rounded-lg shadow-xl w-full max-w-[95vw] sm:max-w-3xl p-4 sm:p-6 text-white"
      >
        <button
          onClick={onClose}
          className="absolute top-2 right-2 sm:top-4 sm:right-4 text-[#dcbc5c] text-2xl font-bold hover:scale-110 transition-transform"
          aria-label={t('cookie_policy.close')}
        >
          ×
        </button>

        <h1 className="text-xl sm:text-2xl font-bold mb-4 text-center">
          {t('cookie_policy.title')}
        </h1>
        <h2 className="text-sm sm:text-base font-medium mb-4 text-center">
          {t('cookie_policy.subtitle')}
        </h2>

        <p className="text-sm sm:text-base mb-6">
          {t('cookie_policy.intro')}
        </p>

        <h2 className="text-base sm:text-lg font-bold mb-2 text-[#dcbc5c]">
          {t('cookie_policy.what_are_cookies.title')}
        </h2>
        <p className="text-sm sm:text-base mb-6">
          {t('cookie_policy.what_are_cookies.content')}
        </p>

        <h2 className="text-base sm:text-lg font-bold mb-2 text-[#dcbc5c]">
          {t('cookie_policy.cookie_types.title')}
        </h2>
        <p className="text-sm sm:text-base mb-2">{t('cookie_policy.cookie_types.list.essential')}</p>
        <p className="text-sm sm:text-base mb-2">{t('cookie_policy.cookie_types.list.performance')}</p>
        <p className="text-sm sm:text-base mb-2">{t('cookie_policy.cookie_types.list.functional')}</p>
        <p className="text-sm sm:text-base mb-6">{t('cookie_policy.cookie_types.list.advertising')}</p>

        <h2 className="text-base sm:text-lg font-bold mb-2 text-[#dcbc5c]">
          {t('cookie_policy.how_we_use.title')}
        </h2>
        <ul className="list-disc pl-4 sm:pl-6 text-sm sm:text-base mb-6 space-y-2">
          {t('cookie_policy.how_we_use.list', { returnObjects: true }).map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>

        <h2 className="text-base sm:text-lg font-bold mb-2 text-[#dcbc5c]">
          {t('cookie_policy.manage_cookies.title')}
        </h2>
        <p className="text-sm sm:text-base mb-2">{t('cookie_policy.manage_cookies.content')}</p>
        <ul className="list-disc pl-4 sm:pl-6 text-sm sm:text-base mb-6 space-y-2">
          <li>{t('cookie_policy.manage_cookies.browsers.chrome')}</li>
          <li>{t('cookie_policy.manage_cookies.browsers.firefox')}</li>
          <li>{t('cookie_policy.manage_cookies.browsers.safari')}</li>
          <li>{t('cookie_policy.manage_cookies.browsers.edge')}</li>
        </ul>

        <h2 className="text-base sm:text-lg font-bold mb-2 text-[#dcbc5c]">
          {t('cookie_policy.your_rights.title')}
        </h2>
        <ul className="list-disc pl-4 sm:pl-6 text-sm sm:text-base mb-6 space-y-2">
          {t('cookie_policy.your_rights.list', { returnObjects: true }).map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>

        <h2 className="text-base sm:text-lg font-bold mb-2 text-[#dcbc5c]">
          {t('cookie_policy.policy_updates.title')}
        </h2>
        <p className="text-sm sm:text-base mb-6">{t('cookie_policy.policy_updates.content')}</p>

        <h2 className="text-base sm:text-lg font-bold mb-2 text-[#dcbc5c]">
          {t('cookie_policy.contact.title')}
        </h2>
        <p className="text-sm sm:text-base mb-2">{t('cookie_policy.contact.content')}</p>
        <p className="text-sm sm:text-base mt-4">{t('cookie_policy.contact.company')}</p>
        <p className="text-sm sm:text-base">{t('cookie_policy.contact.email')}</p>
        <p className="text-sm sm:text-base">{t('cookie_policy.contact.phone')}</p>
      </div>
    </div>
  );
};

export default Cookie;
